/**
 * 发货单 模板设计选项
 */
export const  fhOptions = [
  {
    type: 'braid-txt',
    isEdit: 1,
    title: '自定义文本',
    value: '{自定义文本}',
    defaultValue: '{自定义文本}',
    name: ''
  },
  {
    type: 'braid-txt',
    isEdit: 1,
    title: '页码',
    value: '{第几页/几页}',
    defaultValue: '{第几页/几页}',
    name: ''
  },
  {
    type: 'braid-txt',
    isEdit: 1,
    title: '单据日期',
    value: '{单据日期:}',
    defaultValue: '{单据日期:}',
    name: ''
  },
  {
    type: 'braid-txt',
    isEdit: 1,
    title: '单据编号',
    value: '{单据编号:}',
    defaultValue: '{单据编号:}',
    name: ''
  },
  {
    type: 'braid-txt',
    isEdit: 1,
    title: '下单客户',
    value: '{客   户:}',
    defaultValue: '{客   户:}',
    name: ''
  },
  {
    type: 'braid-txt',
    isEdit: 1,
    title: '客户联系电话',
    value: '{联系电话:}',
    defaultValue: '{联系电话:}',
    name: ''
  },
  {
    type: 'braid-txt',
    isEdit: 1,
    title: '客户地址',
    value: '{客户地址:}',
    defaultValue: '{客户地址:}',
    name: ''
  },
  {
    type: 'braid-txt',
    isEdit: 1,
    title: '公司地址',
    value: '{公司地址:}',
    defaultValue: '{公司地址:}',
    name: ''
  },
  {
    type: 'braid-txt',
    isEdit: 1,
    title: '投诉与建议电话',
    value: '{投诉与建议电话:}',
    defaultValue: '{投诉与建议电话:}',
    name: ''
  },

  {
    type: 'braid-table',
    isEdit: 0,
    title: '发货商品表单',
    name: 'details',
    value: '{details}',
    style: {},
    defaultValue: [
      {
        rownum: '1',
        product_name: '产品名称',
        spec_value: '规格',
        product_code: '产品编号',
        unit: '单位',
        set_num: '1',
        product_price: '23.00',
        amount: '23.00',
        remarks: '',
    
      },
  
    ],
    tabelHtml: '',
    columnsAttr: [
      {
        title: '行号',
        value: '{行号}',
        name: 'rownum',
      },
      {
        title: '商品全名',
        value: '{商品全名}',
        name: 'product_name',
      },
      {
        title: '规格',
        value: '{规格}',
        name: 'spec_value'
      },
      {
        title: '商品编号',
        value: '{商品编号}',
        name: 'product_code'
      },
      {
        title: '单位',
        value: '{单位}',
        name: 'unit'
      },
      {
        title: '数量',
        value: '{数量}',
        name: 'set_num'
      },
      {
        title: '单价',
        value: '{单价}',
        name: 'product_price'
      },
      {
        title: '金额',
        value: '{金额}',
        name: 'amount'
      },
      {
        title: '备注',
        value: '{备注}',
        name: 'remarks'
      },
      // {
      //   title: '产品序列号',
      //   value: '产品序列号明细：<br>{产品序列号}',
      //   name: 'snCode',
      //   trSet: {
      //     title: '产品序列号明细:',
      //     col: 5,
      //     margin: '50px'
      //   },
      // }
    ],
    columns: []
  },
  



]


export const ckStockOptions = [
  {
    type: 'braid-txt',
    isEdit: 1,
    title: '自定义文本',
    value: '{自定义文本}',
    defaultValue: '{自定义文本}',
    name: ''
  },
  {
    type: 'braid-txt',
    isEdit: 1,
    title: '页码',
    value: '{第几页/几页}',
    defaultValue: '{第几页/几页}',
    name: ''
  },
  {
    type: 'braid-txt',
    isEdit: 1,
    title: '单据日期',
    value: '{单据日期:}',
    defaultValue: '{单据日期:}',
    name: ''
  },
  {
    type: 'braid-txt',
    isEdit: 1,
    title: '单据编号',
    value: '{单据编号:}',
    defaultValue: '{单据编号:}',
    name: ''
  },
  {
    type: 'braid-txt',
    isEdit: 1,
    title: '单据编号',
    value: '{单据编号:}',
    defaultValue: '{单据编号:}',
    name: ''
  },
  {
    type: 'braid-txt',
    isEdit: 1,
    title: '下单客户',
    value: '{客   户:}',
    defaultValue: '{客   户:}',
    name: ''
  },
  {
    type: 'braid-txt',
    isEdit: 1,
    title: '客户联系电话',
    value: '{联系电话:}',
    defaultValue: '{联系电话:}',
    name: ''
  },
  {
    type: 'braid-txt',
    isEdit: 1,
    title: '客户地址',
    value: '{客户地址:}',
    defaultValue: '{客户地址:}',
    name: ''
  },
  {
    type: 'braid-txt',
    isEdit: 1,
    title: '公司地址',
    value: '{公司地址:}',
    defaultValue: '{公司地址:}',
    name: ''
  },
  {
    type: 'braid-txt',
    isEdit: 1,
    title: '投诉与建议电话',
    value: '{投诉与建议电话:}',
    defaultValue: '{投诉与建议电话:}',
    name: ''
  },

  {
    type: 'braid-table',
    isEdit: 0,
    title: '出库表单',
    name: 'details1',
    value: '{details1}',
    style: {},
    defaultValue: [
      {
        rownum: '1',
        product_name: '产品名称',
        spec_value: '规格',
        product_code: '产品编号',
        unit: '单位',
        set_num: '1',
        product_price: '23.00',
        amount: '23.00',
        remarks: '',
    
      },
  
    ],
    tabelHtml: '',
    columnsAttr: [
      {
        title: '行号',
        value: '{行号}',
        name: 'rownum',
      },
      {
        title: '商品全名',
        value: '{商品全名}',
        name: 'product_name',
      },
      {
        title: '规格',
        value: '{规格}',
        name: 'spec_value'
      },
      {
        title: '商品编号',
        value: '{商品编号}',
        name: 'product_code'
      },
      {
        title: '单位',
        value: '{单位}',
        name: 'unit'
      },
      {
        title: '数量',
        value: '{数量}',
        name: 'set_num'
      },
      {
        title: '单价',
        value: '{单价}',
        name: 'product_price'
      },
      {
        title: '金额',
        value: '{金额}',
        name: 'amount'
      },
      {
        title: '备注',
        value: '{备注}',
        name: 'remarks'
      },

    ],
    columns: []
  }

  



]



/**
 * 入库单 模板设计选项
 */
export const rkStockOptions = [
  {
    type: 'braid-txt',
    isEdit: 1,
    title: '自定义文本',
    value: '{自定义文本}',
    defaultValue: '{自定义文本}',
    name: ''
  },
  {
    type: 'braid-txt',
    isEdit: 1,
    title: '页码',
    value: '{第几页/几页}',
    defaultValue: '{第几页/几页}',
    name: ''
  },
  {
    type: 'braid-txt',
    isEdit: 1,
    title: '单据日期',
    value: '{单据日期:}',
    defaultValue: '{单据日期:}',
    name: ''
  },
  {
    type: 'braid-txt',
    isEdit: 1,
    title: '下单客户',
    value: '{客   户:}',
    defaultValue: '{客   户:}',
    name: ''
  },
  {
    type: 'braid-txt',
    isEdit: 1,
    title: '客户联系电话',
    value: '{联系电话:}',
    defaultValue: '{联系电话:}',
    name: ''
  },
  {
    type: 'braid-txt',
    isEdit: 1,
    title: '客户地址',
    value: '{客户地址:}',
    defaultValue: '{客户地址:}',
    name: ''
  },
  {
    type: 'braid-txt',
    isEdit: 1,
    title: '公司地址',
    value: '{公司地址:}',
    defaultValue: '{公司地址:}',
    name: ''
  },
  {
    type: 'braid-txt',
    isEdit: 1,
    title: '投诉与建议电话',
    value: '{投诉与建议电话:}',
    defaultValue: '{投诉与建议电话:}',
    name: ''
  },

  {
    type: 'braid-table',
    isEdit: 0,
    title: '入库表单',
    name: 'details1',
    value: '{details1}',
    style: {},
    defaultValue: [
      {
        rownum: '1',
        product_name: '产品名称',
        spec_value: '规格',
        product_code: '产品编号',
        unit: '单位',
        set_num: '1',
        product_price: '23.00',
        amount: '23.00',
        remarks: '',
    
      },
  
    ],
    tabelHtml: '',
    columnsAttr: [
      {
        title: '行号',
        value: '{行号}',
        name: 'rownum',
      },
      {
        title: '商品全名',
        value: '{商品全名}',
        name: 'product_name',
      },
      {
        title: '规格',
        value: '{规格}',
        name: 'spec_value'
      },
      {
        title: '商品编号',
        value: '{商品编号}',
        name: 'product_code'
      },
      {
        title: '单位',
        value: '{单位}',
        name: 'unit'
      },
      {
        title: '数量',
        value: '{数量}',
        name: 'set_num'
      },
      {
        title: '单价',
        value: '{单价}',
        name: 'product_price'
      },
      {
        title: '金额',
        value: '{金额}',
        name: 'amount'
      },
      {
        title: '备注',
        value: '{备注}',
        name: 'remarks'
      },

    ],
    columns: []
  }

]


// WEBPACK FOOTER //
// ./src/views/print/data/options.js